module.exports = __webpack_public_path__ + "media/Instruction_23.90ad99de.mp3";